<template>
  <div class="robot-table">
    <el-table :data="robotTableData" border style="width: 100%" height="78vh">
      <el-table-column prop="date" label="机器人名称" align="center">
        <template slot-scope="scope">
          <Icon name="bottomArrow" />
          <span>{{ scope.row.robotName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="robotType" label="类型" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.robotType =="ROBOT_TYPE_50"? "巡检机器人" : "轻量化巡检机器人" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="robotIp" label="机器人IP" align="center"></el-table-column>
      <el-table-column prop="robotPort" label="端口" align="center"></el-table-column>
      <el-table-column prop="lineName" label="所属线路" align="center"></el-table-column>
      <el-table-column prop="fgtpIp" label="4G图传IP" align="center"></el-table-column>
      <el-table-column prop="robotMac" label="Mac地址" align="center"></el-table-column>
      <el-table-column prop="serialNumber" label="序列号" align="center"></el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button title="编辑机器人信息" @click="handleEdit(scope.row)" type="text" class="table-btn"><i class="el-icon-edit" style="color:#fff;font-size:1.5vh;"></i></el-button>
          <el-button title="删除机器人" @click="deleteRobot(scope.row)" type="text" class="table-btn"><i class="el-icon-delete" style="color:#fff;"></i></el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pager-class">
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page.sync="pageNumber" @current-change="handlePageChange(pageNumber)"></el-pagination>
    </div>
    <el-dialog class="my-dialog" :title="robotDialogTitle" :close-on-click-modal="false" :visible.sync="robotDialogVisible" @closed="closedDialog('robotForm')">
      <el-form :model="robotForm" :rules="robotFormRules" ref="robotForm">
        <el-form-item label="机器人名称" :label-width="formLabelWidth" prop="robotName">
          <el-input v-model.trim="robotForm.robotName" auto-complete="off" placeholder="请输入机器人名称"></el-input>
        </el-form-item>
        <el-form-item label="机器类型" :label-width="formLabelWidth" prop="robotType">
          <el-select v-model.trim="robotForm.robotType" placeholder="请选择机器人类型">
            <el-option v-for="(item, index) in robotTypeOption" :key="index" :label="item.label" :value="item.type"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属公司" :label-width="formLabelWidth" prop="robotType">
          <el-select v-model.trim="robotForm.bureauId" placeholder="请选择公司">
            <el-option v-for="(item, index) in compOption" :key="index" :label="item.label" :value="item.type"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属线路" :label-width="formLabelWidth" prop="lineId">
          <el-select v-model.trim="robotForm.lineId" placeholder="请选择机器人所属线路">
            <el-option v-for="(line, index) in allLinesOption" :key="index" :label="line.lineName" :value="line.lineId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="机器人IP" :label-width="formLabelWidth" prop="robotIp">
          <el-input v-model.trim="robotForm.robotIp" auto-complete="off" placeholder="请输入机器人IP地址"></el-input>
        </el-form-item>
        <el-form-item label="端口号" :label-width="formLabelWidth" prop="robotPort">
          <el-input v-model.trim="robotForm.robotPort" auto-complete="off" placeholder="请输入端口号"></el-input>
        </el-form-item>
        <el-form-item label="4G图传IP" :label-width="formLabelWidth" prop="fgtpIp">
          <el-input v-model.trim="robotForm.fgtpIp" auto-complete="off" placeholder="请输入4G图传IP"></el-input>
        </el-form-item>
        <el-form-item label="Mac地址" :label-width="formLabelWidth" prop="robotMac">
          <el-input v-model.trim="robotForm.robotMac" auto-complete="off" placeholder="请输入机器人Mac地址"></el-input>
        </el-form-item>
        <el-form-item label="序列号" :label-width="formLabelWidth" prop="serialNumber">
          <el-input v-model.trim="robotForm.serialNumber" auto-complete="off" placeholder="请输入序列号"></el-input>
        </el-form-item>
        <el-form-item label="绑定邮箱" :label-width="formLabelWidth" prop="bindEmails">
          <div class="form-emails">
            <div class="form-emails-div">{{bindEmailsStr}}</div> 
            <i class="el-icon-edit-outline form-emails-icon" @click.stop="editEmailsVisiable=true;emails=[].concat(robotForm.bindEmails)"></i>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-button" @click="robotDialogVisible = false">取 消</el-button>
        <el-button class="save-button" @click="save">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="my-dialog" title="编辑绑定邮箱" :close-on-click-modal="false" :visible.sync="editEmailsVisiable">
      <el-button title="新增" class="emails-add" @click.stop="emails.push('')">
        新增
        <i class="el-icon-circle-plus-outline"></i>
      </el-button>
      <el-form :model="emailForm" :rules="emailFormRules" ref="emailFormRef">
        <el-form-item :prop="`emails${index}`" v-for="(item,index) in emails" :key="index">
          <div class="form-emails">
            <el-input v-model.trim="emails[index]" auto-complete="off" placeholder="请输入邮箱地址"></el-input>
            <i class="el-icon-delete form-emails-icon" @click.stop="emails.splice(index,1)"></i>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-button" @click="emails=[];editEmailsVisiable=false">取 消</el-button>
        <el-button class="save-button" @click="saveEmails">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getRobots, getAllLineList, addRobot, getRobotType, delRobot, updateRobot, getRobotFuzzy, getBureauList } from "@/http/equipmentApi.js";
// import qs from "qs";
import Icon from "@/components/Icon.vue";
export default {
  name: "robotTable",
  components: {
    Icon
  },
  computed:{
    bindEmailsStr(){
      return this.robotForm.bindEmails.length==0?"请编辑绑定邮箱":this.robotForm.bindEmails.join('; ')
    },
    emailForm(){
      let res = {}
      this.emails.forEach((item,index)=>{
        res[`emails${index}`] = item
      })
      return res;
    },
    emailFormRules(){
      let res = {}
      this.emails.forEach((item,index)=>{
        res[`emails${index}`] = [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            required: true,
            message: "邮箱地址格式错误",
            pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
            trigger: "blur"
          }
        ]
      })
      return res
    }
  },
  data() {
    return {
      pageNumber: 1,
      pageSize: 10,
      total: 0,
      robotTableData: [],
      isAdd: true,
      robotDialogTitle: "添加机器人",
      robotDialogVisible: false,
      formLabelWidth: "5vw",
      robotTypeOption: [],
      allLinesOption: [],
      compOption:[],
      robotForm: {
        fgtpIp: "192.168.1.164",
        lineId: "",
        robotName: "",
        robotPort: 3000,
        robotIp: "192.168.1.22",
        robotMac: "",
        robotType: "",
        serialNumber: "",
        bureauId:''
      },
      robotFormRules: {
        robotName: [{ required: true, message: "请输入机器人名称", trigger: "blur" }],
        robotType: [{ required: true, message: "请选择机器人类型", trigger: "blur" }],
        bureauId: [{ required: true, message: "请选择公司", trigger: "blur" }],
        // lineId: [{ required: true, message: "请选择所属线路", trigger: "blur" }],
        robotIp: [
          { required: true, message: "请输入机器人IP地址", trigger: "blur" },
          {
            required: true,
            message: "IP地址格式错误",
            pattern: /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/,
            trigger: "blur"
          }
        ],
        robotPort: [
          { required: true, message: "请输入机器人端口号", trigger: "blur" },
          {
            required: true,
            pattern: /^([1-9][0-9]{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]{1}|6553[0-5])$/,
            message: "端口格式错误",
            trigger: "blur"
          }
        ],
        fgtpIp: [
          { required: true, message: "请输入4G图传IP", trigger: "blur" },
          {
            required: true,
            message: "IP地址格式错误",
            pattern: /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/,
            trigger: "blur"
          }
        ],
        robotMac: [
          { required: true, message: "请输入机器人Mac地址", trigger: "blur" },
          {
            required: true,
            min: 11,
            max: 12,
            message: "机器人Mac地址为12位",
            trigger: "blur"
          }
        ],
        rtmp: [{ required: true, message: "请输入摄像头RTMP地址", trigger: "blur" }],
        restartModuleName: [{ required: true, message: "请输入模块名称", trigger: "blur" }],
        serialNumber: [{ required: true, message: "请输入机器人序列号", trigger: "blur" }]
      },
      editEmailsVisiable:false,
      emails:[]
    };
  },
  methods: {
    // 打开对话框
    showDialog() {
      this.robotDialogVisible = true;
    },
    // 关闭对话框时回调
    closedDialog(formName) {
      this.$refs[formName].clearValidate();
      this.isAdd = true;
      this.robotDialogTitle = "添加机器人";
      this.robotForm = {
        fgtpIp: "192.168.1.164",
        lineId: "",
        robotName: "",
        robotPort: 3000,
        robotIp: "192.168.1.22",
        robotMac: "",
        robotType: "",
        serialNumber: "",
        bureauId:''
      };
    },
    // 编辑按钮
    handleEdit(row) {
      this.robotForm = JSON.parse(JSON.stringify(row));
      this.isAdd = false;
      this.robotDialogTitle = "修改机器人信息";
      this.showDialog();
    },
    // 对话框保存按钮
    save() {
      if (this.isAdd) {
        this.addRobotBtn();
      } else {
        this.updateRobot();
      }
    },
    // 添加机器人
    addRobotBtn() {
      let params = this.robotForm;
      this.$refs.robotForm.validate(valid => {
        if (valid) {
          addRobot(params)
            .then(res => {
              if (res.code == "000000") {
                this.$message.success(res.mesg);
                this.robotDialogVisible = false;
                this.getRobotTableData();
              } else {
                this.$message.warning(res.mesg);
              }
            })
            .catch(err => {
              if (err.status == 500) {
                this.$message.warning(err.data.data);
              }
            });
        }
      });
    },
    // 更新机器人
    updateRobot() {
      let params = this.robotForm;
      console.log("🚀 ~ file: robotTable.vue ~ line 270 ~ updateRobot ~ params", params)
      this.$refs.robotForm.validate(valid => {
        if (valid) {
          updateRobot(params).then(res => {
            if (res.code == "000000") {
              this.$message.success(res.mesg);
              this.robotDialogVisible = false;
              this.getRobotTableData();
            } else {+
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    // 删除机器人
    deleteRobot(row) {
      this.$confirm("此操作将永久删除机器人, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(res => {
          console.log(res);
          delRobot({ id: row.id })
            .then(res => {
              if (res.code == '000000') {
                this.$message.success(res.mesg);
                this.getRobotTableData();
              }
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(err => {
          console.log(err, "取消操作");
        });
    },
    // 获取机器人表格数据
    getRobotTableData() {
      let params = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize
      };
      getRobots(params).then(res => {
        this.robotTableData = res.rows;
        this.total = res.total;
      });
    },
    // 获取全部线路,添加时下拉框选择
    getAllLineList() {
      getAllLineList().then(res => {
        this.allLinesOption = res.data;
      });
    },
    // 获取机器人类型，添加时下拉框选择
    getRobotTypeList() {
      getRobotType().then(res => {
        if (res.code === "000000") {
          this.robotTypeOption = res.data.map(item => ({
            // type: String(item.number),
            type:item.key,
            label: item.value
          }));
        }
      });
    },
    //获取公司列表
    getBureauList(){
      getBureauList().then(res => {
        if (res.code === "000000") {
          this.compOption = res.data.map(item => ({
            type:item.bureauId,
            label: item.bureauName,
            ...item
          }));
        }
      });
    },
    // 点击分页页码
    handlePageChange(pageNumber) {
      this.pageNumber = pageNumber;
      // 调用分页查询接口
     this.searchRobot(this.$parent.searchKey);
    },
    // 模糊查询机器人
    searchRobot(keyWord) {
      let params = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        robotName: keyWord
      };
      getRobots(params).then(res => {
        this.robotTableData = res.rows;
        this.total = res.total;
      });
    },
    //保存绑定邮箱
    saveEmails(){
      this.$refs.emailFormRef.validate(valid => {
        if (valid) {
          this.robotForm.bindEmails = [].concat(this.emails)
          this.editEmailsVisiable=false
        }})
    }
  },
  mounted() {
    this.getRobotTableData();
    this.getAllLineList();
    this.getRobotTypeList();
    this.getBureauList()
  }
};
</script>
<style lang="scss" scoped>
.form-emails{
  border-radius: 0;
  min-height: 40px;
  background-color: transparent;
  color: #fff;
  display: flex;
  align-items: center;
  .form-emails-div{
    border: 0.1vh solid #00a880;
    line-height: 3vh;
    min-height: 3vh;
    width: 250px;
    padding: 0 15px;
  }
  .form-emails-icon{
    margin-left: auto;
    cursor: pointer;
  }
}
.emails-add{
  background: url(data:image/png;base64,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) no-repeat;
  background-size: 100% 100%;
  background-position: center;
  color: #fff;
  padding: 0;
  width: 5vw;
  height: 3.2vh;
  font-size: 0.7vw;
  border-color: transparent;
  margin-bottom: 20px;
}
.pager-class {
  display: flex;
  justify-content: center;
}
</style>
